import dynamicImportPolyfill from 'dynamic-import-polyfill';
import { initFrontendScripts } from './main.js';

dynamicImportPolyfill.initialize({
    modulePath: '/',
});

initFrontendScripts();
